export class ContactFormData{
    name:string;
    email:string;
    mobileNumber:any;
    message:string;

}